import { Message } from "hanshow-ui";
import i18n from "@/i18n";
let messageInstancesList = [];
let defaultMessageList = [];
export default function createNotice(
  messageContent,
  messageOther = {},
  messageType = "default",
  bindProps = {}
) {
  if (messageType != "default" && messageInstancesList.length > 2) {
    let closeInstance = messageInstancesList.shift();
    closeInstance.close();
  }
  let instance = Message({
    title: "",
    iconClass: "none",
    message:
      typeof messageContent == "string"
        ? i18n.t(messageContent, messageOther)
        : messageContent,
    showClose: true,
    ...bindProps,
    customClass: `message-box message-box-${messageType} ${
      bindProps.customClass ? bindProps.customClass : ""
    }`,
  });
  if (messageType != "default") {
    messageInstancesList.push(instance);
  }else{
    defaultMessageList.push(instance)
  }
  return instance;
}
export function closeAllMessage() {
  messageInstancesList.forEach((item) => {
    item.closeAll=true;
    item.close();
  });
  defaultMessageList.forEach(item=>{
    item.close();
  })
  messageInstancesList = [];
  defaultMessageList = [];
}
export function closeMessage(item){
  if(item){
    const index = messageInstancesList.findIndex(instance=>instance.id==item.id);
    if(index!=-1){
      messageInstancesList.splice(index,1);
    }
    const defaultIndex = defaultMessageList.findIndex(instance=>instance.id==item.id);
    if(defaultIndex!=-1){
      defaultMessageList.splice(defaultIndex,1)
    }
  }
}